import move from 'lodash-move'
import Sortable from 'sortablejs'

// eslint-disable-next-line @typescript-eslint/no-use-before-define
export default ['storyService', directive]

function directive(storyService) {
  return {
    restrict: 'EA',
    require: '^ngModel',
    link: (scope, element, attrs, ngModel) => {
      // element or list?
      const el = element.find('ul')[0] || element
      // sortable options
      const options = {
        onSort: (e) => {
          // create new array with updated order
          const update = move(ngModel.$modelValue, e.oldIndex, e.newIndex)
          // update model
          ngModel.$setViewValue(update)
          // call rerend
          ngModel.$render()
          // Warning for saving
          storyService.isDirty(true)
        },
      }
      // init list
      const list = new Sortable(el, options)

      scope.$on('$destroy', () => {
        list.destroy()
      })
    },
  }
}
